/**
 * 포트원(아임포트) 결제 요청 공통 처리.
 *
 * 페이지마다 결제 요청 정보가 제각각이라 어떤 화면은 되고 어떤 화면은
 * 결제창이 뜨다 마는 문제가 있었다(KG이니시스는 구매자 연락처가 없거나
 * 상품명에 특수문자가 들어가면 거부한다). 여기 한 곳에서 안전한 형태로 맞춘다.
 */
const IMP_CODE = process.env.REACT_APP_IMP_CODE || "";

export type PayOpts = {
  merchantUid: string;
  name: string;
  amount: number;
  buyerName?: string;
  buyerEmail?: string;
  buyerTel?: string;
  /** 휴대폰 결제 후 돌아올 주소 (없으면 현재 주소) */
  redirectUrl?: string;
};

export type PayResult = {
  success: boolean;
  imp_uid?: string;
  merchant_uid?: string;
  error_msg?: string;
};

/** 상품명 정리 — 이니시스가 거부하는 특수문자 제거, 길이 제한 */
function safeName(raw: string): string {
  const cleaned = (raw || "우연 사주")
    .replace(/[—–·•~^|\\"'<>{}[\]]/g, " ")   // 특수문자 → 공백
    .replace(/\s+/g, " ")
    .trim();
  return (cleaned || "우연 사주").slice(0, 40);
}

/** 전화번호 정리 — 이니시스 필수값이라 비면 기본값을 넣는다 */
function safeTel(raw?: string): string {
  const digits = (raw || "").replace(/[^0-9]/g, "");
  return digits.length >= 9 ? digits : "01000000000";
}

function safeEmail(raw?: string): string {
  const v = (raw || "").trim();
  return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v) ? v : "noreply@wooyeon.co.kr";
}

export function isPayReady(): boolean {
  return typeof (window as any).IMP !== "undefined" && !!IMP_CODE;
}

/** 결제창 호출 — 콜백(PC) 결과를 Promise로 돌려준다. 휴대폰은 redirectUrl로 이동. */
export function requestPay(opts: PayOpts): Promise<PayResult> {
  return new Promise((resolve) => {
    const IMP = (window as any).IMP;
    if (!IMP) {
      resolve({ success: false, error_msg: "결제 모듈이 아직 준비되지 않았습니다. 잠시 후 다시 시도해 주세요." });
      return;
    }
    if (!IMP_CODE) {
      resolve({ success: false, error_msg: "결제 설정(가맹점 코드)이 없습니다. 관리자에게 문의해 주세요." });
      return;
    }
    IMP.init(IMP_CODE);
    IMP.request_pay(
      {
        pg: "html5_inicis",
        pay_method: "card",
        merchant_uid: opts.merchantUid,
        name: safeName(opts.name),
        amount: Math.max(100, Math.round(opts.amount || 0)),
        buyer_name: (opts.buyerName || "고객").trim().slice(0, 20) || "고객",
        buyer_tel: safeTel(opts.buyerTel),
        buyer_email: safeEmail(opts.buyerEmail),
        m_redirect_url: opts.redirectUrl || window.location.href,
      },
      (rsp: any) => {
        resolve({
          success: !!rsp?.success,
          imp_uid: rsp?.imp_uid,
          merchant_uid: rsp?.merchant_uid,
          error_msg: rsp?.error_msg,
        });
      },
    );
  });
}
